<template>
  <div class="clockin">
    <Header></Header>
    <div class="head">
      <div class="title">亲爱的爸爸妈妈：</div>
      <p>这是我今天的成长任务，请检查我做的任务好吗？</p>
    </div>
    <div class="taskList">
      <div class="taskItem" v-for="(item,index) in taskList" :key="item.id">
        <div>
          <div>
            <img src="../assets/images/listStyle.png" alt />
            <p>{{item.taskName}}</p>
          </div>
          <div :class="item.taskStatus==0?'punch':'done'" @click="clockIn(item,index)">{{item.taskStatus==0?'打卡':'已完成'}}</div>
        </div>
        <div>
          <img src alt />
          <p>+{{item.taskIntegral}}积分奖励</p>
        </div>
      </div>
    </div>
    <div class="process">
      <div class="title">任务进程</div>
      <div class="content">
        <div>
          <img src alt />
          <div>
            <p>完成任务</p>
            <div>领取/积分/奖励 | 任务总计：{{taskList.length}}个</div>
          </div>
        </div>
        <div class="process-wrap">
          <div :style="'width:'+(doneNum/taskList.length)*100+'%'"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast} from "vant";
import {finishTask,getAlltaskList} from "../api/api-childTask"
import { mapState } from "vuex";
import Header from "../components/Header";
export default {
  components: {
    Header
  },
  data() {
    return {
        taskList:[]
    };
  },
  computed: {
       ...mapState({
      userInfo: state => state.userInfo,
      childInfo: state => state.childInfo,
      activeChildInfo: state => state.activeChildInfo
    }),
    doneNum(){
        let count=0;
        this.taskList.forEach(item=>{
            if(item.taskStatus==1){
                count=count+1
            }
        })
        return count
    }
  },
  watch: {},
  methods: {
      getTaskList(){
         let childId=this.activeChildInfo.id;
         getAlltaskList(childId).then(res=>{
             if(res.code==200){
                 this.taskList=res.data
             }else{
                Toast.fail(res.msg)
             }
         }) 
      },
      clockIn(item,idx){
        if(item.taskStatus==0){
            finishTask(item.id).then(res=>{
                if(res.code==200){
                    this.taskList[idx].taskStatus=1
                }else{
                    Toast.fail(res.msg)
                }
            })
        }
      }
  },
  created() {
      this.getTaskList()
  },
  mounted() {}
};
</script>
<style scoped lang="less">
.clockin {
  color: #333;
}
.head {
  padding: 10px 15px 0 10px;
  color: #333;
  p {
    font-size: 15px;
    margin-top: 7px;
    padding-left: 13px;
  }
}
.title {
  font-size: 16px;
  font-weight: bold;
}
.taskList {
  padding-left: 28px;
  padding-right: 15px;
  margin-top: 20px;
  .taskItem:last-of-type > div:last-child{
      border-bottom: 1px solid #f2f4f6;
  }
  .taskItem > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #f2f4f6;
    padding-top: 14px;
    & > div:first-child {
      display: flex;
      align-items: center;
      img {
        width: 17px;
        height: 17px;
      }
    }
    & > div:last-child {
      width: 66px;
      height: 24px;
      border-radius: 15px;
      line-height: 24px;
      text-align: center;
      font-size: 14px;
    }
    .punch{
        background: #87E2CD;
        color: #fff;
    }
    .done{
        background: #eee;
        color:#333;
    }
  }
  .taskItem > div:last-child{
      display: flex;
      padding-left: 20px;
      padding-bottom: 15px;
      margin-top: 7px;
      img{
          width: 20px;
          height: 20px;
      }
  }
}
.process{
    padding: 0 15px;
    margin-top: 16px;
    .process-wrap{
      margin-top: 16px
    }
    .content {
      margin-top: 10px;
      padding: 17px 20px 15px 30px;
      background: url("../assets/images/finish-task.png");
      background-size: cover;
        &>div:first-child{
            display: flex;
            align-items: center;
            padding-left: 10px;
            img{
                width: 40px;
                height: 60px;
                margin-right: 12px;
            }
            &>div{
                p{
                    font-size: 24px;
                    color: #333;
                }
                div{
                    font-size: 14px;
                    color: #999;
                    margin-top: 4px;
                }
            }
        }
        &>div:last-child{
            width: 100%;
            height: 4px;
            border-radius: 5px;
            background: #fff;
            div{
               height: 4px;
            border-radius: 5px;
            background: #87E2CD;
             
            }
        }
    }
}
</style>
